import { useState } from "react";


function BezpiecznyKredytRata (props) {

    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
    let interestRate = 0;
    if(props.id === 53 || props.id === 59 || props.id === 60){interestRate = 7.97/1200} // pkobp

    if(props.id === 54){interestRate = 7.14/1200} //pekao sa
    if(props.id === 55){interestRate = 7.14/1200}

    if(props.id === 56){interestRate = 7.089/1200}
    if(props.id === 57){interestRate = 6.899/1200}
    if(props.id === 58){interestRate = 7.499/1200} // alior standard
    let interestRateBezpiecznyKredyt = interestRate;
   // let interestRateBezpiecznyKredyt3 = 6.46/1200;
    let interestRate2Procent = 2;
    let loanPeriod = props.loanPeriod;
    let loanPeriodBezpiecznyKredyt = 120;
    let loanPeriod2 = loanPeriod - 120;
    let kapitałPo10Latach = creditValue - (120*(creditValue/loanPeriod))

    //for (let i = 0; i <= 120; i++) {
 
    //    creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
    //}
    const paymentRate = (kapitałPo10Latach*interestRate*Math.pow(1 + interestRate, loanPeriod2)) / (Math.pow(1 + interestRate, loanPeriod2) - 1);
    const paymentRate2 = (creditValue/loanPeriod) + (interestRate*props.creditValue);
    const zwykłyDecreasing = (creditValue/loanPeriod) + (interestRate*creditValue);
    const dopłata = creditValue * (wskaźnikKwartalnejStopy - 2)/1200;
    const paymentRateBK = zwykłyDecreasing - dopłata;
    const test3 = paymentRate2 - paymentRateBK;

    
    return paymentRateBK.toFixed(2);
}

function DopłataDoBK2(props){
  
    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
   
    const dopłata = creditValue * (wskaźnikKwartalnejStopy - 2)/1200;

    return dopłata.toFixed(2);  
}

function BezpiecznyKredytRataDocelowa (props) {

    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
    let interestRate = 0;
    if(props.id === 53 || props.id === 59 || props.id === 60){interestRate = 7.97/1200} // pkobp

    if(props.id === 54){interestRate = 7.14/1200} //pekao sa
    if(props.id === 55){interestRate = 7.14/1200}

    if(props.id === 56){interestRate = 7.089/1200}
    if(props.id === 57){interestRate = 6.899/1200}
    if(props.id === 58){interestRate = 7.499/1200} // alior standard
  
    let loanPeriod = props.loanPeriod;
    let loanPeriodBezpiecznyKredyt = 120;
    let loanPeriod2 = loanPeriod - 120;
    let kapitałPo10Latach = creditValue - (120*(creditValue/loanPeriod))

    //for (let i = 0; i <= 120; i++) {
 
    //    creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
    //}
    const paymentRate = (kapitałPo10Latach*interestRate*Math.pow(1 + interestRate, loanPeriod2)) / (Math.pow(1 + interestRate, loanPeriod2) - 1);
    const paymentRate2 = (creditValue/loanPeriod) + (interestRate*props.creditValue);
    const zwykłyDecreasing = (creditValue/loanPeriod) + (interestRate*creditValue);
    const dopłata = creditValue * (wskaźnikKwartalnejStopy - 2)/1200;
    const paymentRateBK = zwykłyDecreasing - dopłata;
    const test3 = paymentRate2 - paymentRateBK;
    

    return paymentRate.toFixed(2);
}

function BezpiecznyKredytRataDocelowaDecreasing (props) {

    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
    let interestRate = 0;
    if(props.id === 53 || props.id === 59 || props.id === 60){interestRate = 7.97/1200} // pkobp

    if(props.id === 54){interestRate = 7.14/1200} //pekao sa
    if(props.id === 55){interestRate = 7.14/1200}

    if(props.id === 56){interestRate = 7.089/1200}
    if(props.id === 57){interestRate = 6.899/1200}
    if(props.id === 58){interestRate = 7.499/1200} // alior standard
  
    let loanPeriod = props.loanPeriod;
    let loanPeriodBezpiecznyKredyt = 120;
    let loanPeriod2 = loanPeriod - 120;
    let kapitałPo10Latach = creditValue - (120*(creditValue/loanPeriod))

    //for (let i = 0; i <= 120; i++) {
 
    //    creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
    //}
    let paymentRate = (creditValue/loanPeriod) + (interestRate * kapitałPo10Latach)
    

    return paymentRate.toFixed(2);
}

function BezpiecznyKredytKosztCałkowity(props) {
    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
    let interestRate = 0;
    if(props.id === 53 || props.id === 59 || props.id === 60){interestRate = 7.97/1200} // pkobp

    if(props.id === 54){interestRate = 7.14/1200} //pekao sa
    if(props.id === 55){interestRate = 7.14/1200}

    if(props.id === 56){interestRate = 7.089/1200}
    if(props.id === 57){interestRate = 6.899/1200}
    if(props.id === 58){interestRate = 7.499/1200} // alior standard
    let loanPeriod = props.loanPeriod;
    let loanPeriodBezpiecznyKredyt = 120;
    let loanPeriod2 = loanPeriod - 120;
    let tylkoKapitał = creditValue/loanPeriod;
    let kapitałPo10Latach = creditValue - (120*(creditValue/loanPeriod))
    let kapitałPo10Latach2 = creditValue - (119*(creditValue/loanPeriod))
    let odsetkiPierwsze10lat = 0;
    let odsetkiPierwszaRata = 0;
    let odsetkiOstatniaRata = 0;
    let odsetkiReszta = 0;
    let kapitał = creditValue/loanPeriod;
  
    const paymentRate = (kapitałPo10Latach*interestRate*Math.pow(1 + interestRate, loanPeriod2)) / (Math.pow(1 + interestRate, loanPeriod2) - 1);
    const dopłataPierwsza = creditValue * (wskaźnikKwartalnejStopy - 2)/1200;
    const dopłataOstatnia = kapitałPo10Latach * (wskaźnikKwartalnejStopy - 2)/1200;
   
    
    
    odsetkiPierwszaRata = interestRate*creditValue;
    odsetkiOstatniaRata =  interestRate * kapitałPo10Latach2;
    odsetkiPierwsze10lat = (odsetkiPierwszaRata + odsetkiOstatniaRata) * 60; // 60 bo 120mcy /2
    const dopłaty10Lat = (dopłataPierwsza + dopłataOstatnia) * 60;
    odsetkiReszta = (paymentRate * loanPeriod2);
  
      const bezpiecznyKredytKosztCałkowity = odsetkiPierwsze10lat - dopłaty10Lat + odsetkiReszta - kapitałPo10Latach;
    

    return bezpiecznyKredytKosztCałkowity.toFixed(2);
}

function BezpiecznyKredytKosztSumaDopłat(props) {
    let creditValue = props.creditValue;
    let wskaźnikKwartalnejStopy = 7.14;
    let interestRate = 0;
    if(props.id === 53 || props.id === 59 || props.id === 60){interestRate = 7.97/1200} // pkobp

    if(props.id === 54){interestRate = 7.14/1200} //pekao sa
    if(props.id === 55){interestRate = 7.14/1200}

    if(props.id === 56){interestRate = 7.089/1200}
    if(props.id === 57){interestRate = 6.899/1200}
    if(props.id === 58){interestRate = 7.499/1200} // alior standard
    let loanPeriod = props.loanPeriod;
    let loanPeriodBezpiecznyKredyt = 120;
    let loanPeriod2 = loanPeriod - 120;
    let tylkoKapitał = creditValue/loanPeriod;
    let kapitałPo10Latach = creditValue - (120*(creditValue/loanPeriod))
    let kapitałPo10Latach2 = creditValue - (119*(creditValue/loanPeriod))
    let odsetkiPierwsze10lat = 0;
    let odsetkiPierwszaRata = 0;
    let odsetkiOstatniaRata = 0;
    let odsetkiReszta = 0;
    let kapitał = creditValue/loanPeriod;
  
    const paymentRate = (kapitałPo10Latach*interestRate*Math.pow(1 + interestRate, loanPeriod2)) / (Math.pow(1 + interestRate, loanPeriod2) - 1);
    const zwykłyDecreasing = (creditValue/loanPeriod) + (interestRate*creditValue);
    const zwykłyDecreasingOstatnia = interestRate * kapitałPo10Latach2;
    //const dopłata = creditValue * (interestRateBezpiecznyKredyt - interestRate2Procent)/1200;
    const dopłata = zwykłyDecreasing - paymentRate;
    const dopłataPierwsza = creditValue * (wskaźnikKwartalnejStopy - 2)/1200;
    const dopłataOstatnia = kapitałPo10Latach * (wskaźnikKwartalnejStopy - 2)/1200;
    const paymentRateBK = zwykłyDecreasing + dopłata;
    
    
    odsetkiPierwszaRata = zwykłyDecreasing - tylkoKapitał
    odsetkiOstatniaRata =  zwykłyDecreasingOstatnia - tylkoKapitał
    odsetkiPierwsze10lat = (odsetkiPierwszaRata + odsetkiOstatniaRata) * 60; // 60 bo 120mcy /2
    const dopłaty10Lat = (dopłataPierwsza + dopłataOstatnia) * 60;
    odsetkiReszta = (paymentRate * loanPeriod2);
  
   
    

    return dopłaty10Lat.toFixed(2);
}




export default BezpiecznyKredytRata
export {BezpiecznyKredytKosztCałkowity}
export {BezpiecznyKredytRataDocelowa}
export {BezpiecznyKredytRataDocelowaDecreasing}
export {DopłataDoBK2}
export {BezpiecznyKredytKosztSumaDopłat}